import React, { useState } from 'react';
import { Facebook, Instagram } from 'lucide-react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />
      
      <main className="flex-grow">
        {/* Page Title */}
        <div className="bg-white py-12">
          <h1 className="text-4xl md:text-5xl font-normal text-center text-gray-900">Contact Us</h1>
        </div>

        {/* Google Maps */}
        <div className="w-full h-[400px] md:h-[450px]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3316.4869747144844!2d-118.08456492431234!3d33.77081327327831!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dd30b0a5f0f8d3%3A0x5b8f8b8f8b8f8b8f!2s16331%20Arthur%20St%2C%20Cerritos%2C%20CA%2090703!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Store Location"
          ></iframe>
        </div>

        {/* Contact Information and Form */}
        <div className="max-w-7xl mx-auto px-8 py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Left Column - Contact Information */}
            <div className="space-y-8">
              {/* Address */}
              <div>
                <h3 className="text-lg font-bold mb-3">Address</h3>
                <p className="text-gray-700">16331 Arthur St Cerritos, CA 90703, United States</p>
              </div>

              {/* Phone */}
              <div>
                <h3 className="text-lg font-bold mb-3">Phone</h3>
                <p className="text-gray-700">
                  CALL/TEXT:{' '}
                  <a
                    href="tel:562-417-2864"
                    className="text-gray-900 hover:text-[#6B9FA8] transition-colors underline"
                  >
                    562-417-2864
                  </a>
                </p>
              </div>

              {/* Email */}
              <div>
                <h3 className="text-lg font-bold mb-3">Email</h3>
                <a
                  href="mailto:sales@hnuapparel.com"
                  className="text-gray-900 hover:text-[#6B9FA8] transition-colors underline"
                >
                  sales@hnuapparel.com
                </a>
              </div>

              {/* Opening Hours */}
              <div>
                <h3 className="text-lg font-bold mb-3">Opening Hours:</h3>
                <p className="text-gray-700">MON to SAT: 9:00AM - 05:00PM</p>
              </div>

              {/* Social Media */}
              <div className="flex items-center space-x-4 pt-4">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 border border-gray-300 rounded-full flex items-center justify-center hover:border-[#6B9FA8] hover:text-[#6B9FA8] transition-colors"
                  aria-label="Facebook"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 border border-gray-300 rounded-full flex items-center justify-center hover:border-[#6B9FA8] hover:text-[#6B9FA8] transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram className="w-5 h-5" />
                </a>
              </div>
            </div>

            {/* Right Column - Contact Form */}
            <div className="bg-white">
              <h2 className="text-2xl font-normal mb-4">Get in Touch</h2>
              <p className="text-gray-600 text-sm mb-8">
                We'd love to hear from you - please use the form to send us your message or ideas. Or simply pop in to meet.
              </p>

              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Name and Email Row */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm text-gray-700 mb-2">
                      Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-none focus:outline-none focus:border-gray-900 transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-700 mb-2">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-none focus:outline-none focus:border-gray-900 transition-colors"
                    />
                  </div>
                </div>

                {/* Message */}
                <div>
                  <label className="block text-sm text-gray-700 mb-2">
                    Message <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="8"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-none focus:outline-none focus:border-gray-900 transition-colors resize-none"
                  ></textarea>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="w-full bg-black text-white py-4 px-6 rounded-none hover:bg-gray-800 transition-colors font-medium"
                >
                  Send
                </button>
              </form>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ContactUs;
